(function () {
	const addClasses = (slider) => {
		const sliderWrapper = slider.querySelector(".multicolumn-list__wrapper");
		const slides = slider.querySelectorAll(".multicolumn-list__item");

		slider.classList.add("swiper");
		if (sliderWrapper) sliderWrapper.classList.add("swiper-wrapper");
		if (slides.length > 1) {
			slides.forEach((slide) => {
				slide.classList.add("swiper-slide");
			});
		}
	};

	const removeClasses = (slider) => {
		const sliderWrapper = slider.querySelector(".multicolumn-list__wrapper");
		const slides = slider.querySelectorAll(".multicolumn-list__item");

		slider.classList.remove("swiper");
		if (sliderWrapper) sliderWrapper.classList.remove("swiper-wrapper");
		slides.forEach((slide) => {
			slide.removeAttribute("style");
			slide.classList.remove("swiper-slide");
		});
	};

	const initSlider = (section) => {
		const slider = section.querySelector(".swiper--multicolumn");

		if (slider) {
			addClasses(slider);

			new Swiper(slider, {
				loop: false,
				speed: 800,
				breakpoints: {
					320: {
						slidesPerView: 1,
						slidesPerGroup: 1,
						// spaceBetween: 16,
					},
					750: {
						slidesPerView: 2,
						slidesPerGroup: 2,
						spaceBetween: 32,
					},
				},
				pagination: {
					el: '.multicolumn-carousel-dots',
					clickable: true,
				},
				navigation: {
					prevEl: slider.querySelector(".multicolumn-carousel-arrow-prev"),
					nextEl: slider.querySelector(".multicolumn-carousel-arrow-next"),
				},
			});
		}
	};

	const destroySlider = (section) => {
		const slider = section.querySelector(".swiper--multicolumn");

		if (slider) {
			removeClasses(slider);
		}
	};

	const initSection = (section) => {
		if (section && section.classList.contains("multicolumn-section")) {
			const sectionResizeObserver = new ResizeObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.contentRect.width < 990) {
						initSlider(entry.target);
					} else {
						destroySlider(entry.target);
					}
				});
			});

			sectionResizeObserver.observe(section);
		}
	};

	initSection(document.currentScript.parentElement);

	document.addEventListener("shopify:section:load", function (section) {
		initSection(section.target);
	});
})();
